import React from 'react';
import { ServiceRequestResponse } from '@/api/bol';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';

export interface ServiceRequestDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  serviceRequest: ServiceRequestResponse | null;
}

export const ServiceRequestDeleteDialog: React.FC<ServiceRequestDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  serviceRequest,
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="service-request"
      itemId={serviceRequest?.id || ''}
    />
  );
};
